import React from 'react'

import ContentPage from './ContentPage.jsx'

import es from '../locales/contact_es.json'
import en from '../locales/contact_en.json'

function Contact() {
    return <ContentPage es={es} en={en} />
}

export default Contact
